import { render } from "./Spinner.vue?vue&type=template&id=39ef9381&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=39ef9381&scoped=true&lang=css"

import exportComponent from "/Users/martins/www/doarbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ef9381"]])

export default __exports__